/*
 * Rewrites the Opinew "(11)" review-count link next to the product title into an average
 * rating like "4,8/5". Opinew's app block only exposes the average inside a large JSON blob
 * on #opinew-plugin[data-opw-prodreviews] (meant for its own widget JS to read), not as a
 * plain attribute, so this has to be JS rather than CSS. Both the plugin element and the
 * count span it targets are injected asynchronously by Opinew's own script, so this observes
 * the page for their arrival instead of running once on load.
 */
(function () {
  function formatAverage(value) {
    if (typeof value !== 'number' || !isFinite(value) || value <= 0) return null;
    return value.toFixed(1).replace('.', ',') + '/5';
  }

  function applyRating() {
    var pluginEl = document.getElementById('opinew-plugin');
    if (!pluginEl) return;
    var raw = pluginEl.getAttribute('data-opw-prodreviews');
    if (!raw) return;

    var data;
    try {
      data = JSON.parse(raw);
    } catch (e) {
      return;
    }

    var text = formatAverage(data && data.product && data.product.average_stars);
    if (!text) return;

    document.querySelectorAll('.opinew-stars-plugin-link .opinew-no-reviews-stars-plugin').forEach(function (el) {
      if (el.textContent.trim() !== text) {
        el.textContent = text;
      }
    });
  }

  function watchCountSpans() {
    document.querySelectorAll('.opinew-stars-plugin-link .opinew-no-reviews-stars-plugin').forEach(function (span) {
      if (span.dataset.opwRatingWatched) return;
      span.dataset.opwRatingWatched = 'true';
      new MutationObserver(applyRating).observe(span, {
        childList: true,
        characterData: true,
        subtree: true
      });
    });
  }

  function watchPluginAttribute() {
    var pluginEl = document.getElementById('opinew-plugin');
    if (!pluginEl || pluginEl.dataset.opwRatingWatched) return;
    pluginEl.dataset.opwRatingWatched = 'true';
    new MutationObserver(applyRating).observe(pluginEl, {
      attributes: true,
      attributeFilter: ['data-opw-prodreviews']
    });
  }

  function tick() {
    applyRating();
    watchCountSpans();
    watchPluginAttribute();
  }

  function init() {
    tick();
    new MutationObserver(tick).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
